/**
 * The Governance Registers route table (FND-FR-086, FND-FR-089, FND-FR-090).
 *
 * `web/src/router/index.ts` and `web/src/nav/parts/p01-enterprise.ts` are
 * shared files that this packet DOES own and will wire itself.
 *
 * All three registers are read-only governance views gated on their read permissions.
 */

import type { RouteRecordRaw } from 'vue-router'

import { GOVERNANCE_PERMISSIONS } from '@/modules/enterprise/governance/permissions'

export const GOVERNANCE_BASE = '/enterprise/governance'

export function mastershipRegisterRoute(): string {
  return `${GOVERNANCE_BASE}/mastership`
}

export function dependencyPostureRegisterRoute(): string {
  return `${GOVERNANCE_BASE}/dependency-postures`
}

export function classificationRegisterRoute(): string {
  return `${GOVERNANCE_BASE}/classifications`
}

export const GOVERNANCE_ROUTES: RouteRecordRaw[] = [
  {
    path: `${GOVERNANCE_BASE}/mastership`,
    name: 'enterprise-governance-mastership',
    component: () => import('@/modules/enterprise/governance/MastershipRegisterView.vue'),
    meta: {
      titleKey: 'enterprise.governance.routeTitles.mastership',
      permission: GOVERNANCE_PERMISSIONS.mastershipRead,
    },
  },
  {
    path: `${GOVERNANCE_BASE}/dependency-postures`,
    name: 'enterprise-governance-dependency-postures',
    component: () => import('@/modules/enterprise/governance/DependencyPostureRegisterView.vue'),
    meta: {
      titleKey: 'enterprise.governance.routeTitles.dependencyPostures',
      permission: GOVERNANCE_PERMISSIONS.dependencyPostureRead,
    },
  },
  {
    path: `${GOVERNANCE_BASE}/classifications`,
    name: 'enterprise-governance-classifications',
    component: () => import('@/modules/enterprise/governance/ClassificationRegisterView.vue'),
    meta: {
      titleKey: 'enterprise.governance.routeTitles.classifications',
      permission: GOVERNANCE_PERMISSIONS.classificationRead,
    },
  },
]
